import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { ProductFulfillment } from 'models/interfaces';

const LIST_PRODUCT_FULFILLMENT = gql`
  query ListProductFulfillments {
    productFulfillments {
      opportunity_id
      item_id
      tgrams_id
      product_sku
      quantity
      start_date
      end_date
      campaign_id
      thomas_campaign {
        campaign_id
        tgrams_id
        product_id
        name
        start_date
        end_date
        status_id
        created_date
      }
      thomas_advertiser {
        tgrams_id
        name
      }
      configuration_workflow_arn
      configuration_activity_token
      created_date
      last_updated_date
      last_updated_by
    }
  }
`;

const LIST_PRODUCT_FULFILLMENT_REDUCED = gql`
  query ListProductFulfillmentsReduced($size: Int, $from: Int) {
    productFulfillmentsReduced(size: $size, from: $from) {
      productFulfillmentReducedList {
        account_name
        campaign_name
        tgrams_id
        start_date
        end_date
        opportunity_id
        campaign_id
        item_id
        product_id
        status_id
        quantity
      }
      queryInfo {
        resultsCount
        success
        message
      }
    }
  }
`;

const LIST_PRODUCT_FULFILLMENT_BY_STATUS = gql`
  query ListProductFulfillmentsByStatus($status_id: number) {
    productFulfillmentsByStatus(status_id: $status_id) {
      tgrams_id
      name
      pvsCampaigns {
        pvs_campaign_id
      }
    }
  }
`;

interface ProductFulfillmentListContainerRenderProps {
  productFulfillments: ProductFulfillment[];
  resultsCount?: number;
}

interface ProductFulfillmentListContainerProps {
  status_id?: number;
  size?: number;
  from?: number;
  children: (props: ProductFulfillmentListContainerRenderProps) => any;
}

const ProductFulfillmentListContainer: React.FunctionComponent<
  ProductFulfillmentListContainerProps
> = ({ children, status_id, size, from, ...props }) => {
  let query = LIST_PRODUCT_FULFILLMENT;

  if (status_id) {
    query = LIST_PRODUCT_FULFILLMENT_BY_STATUS;
  }

  if (size !== null && from !== null) {
    query = LIST_PRODUCT_FULFILLMENT_REDUCED;
  }

  return (
    <Query<any> query={query} variables={{ size, from }}>
      {({ data: { productFulfillments, productFulfillmentsReduced }={
         productFulfillments: {} as any, productFulfillmentsReduced: {} as any
      }, loading }) => {
        if (loading) {
          return null;
        }
        let productFulfillmentsList = productFulfillments;
        let resultsCount = 0;
        if (query === LIST_PRODUCT_FULFILLMENT_REDUCED) {
          productFulfillmentsList = productFulfillmentsReduced.productFulfillmentReducedList;
          resultsCount = productFulfillmentsReduced.queryInfo.resultsCount;
        }

        return (
          children &&
          children({
            ...props,
            productFulfillments: productFulfillmentsList,
            resultsCount
          })
        );
      }}
    </Query>
  );
};

export default ProductFulfillmentListContainer;
